<script>
import AppBanner from '@/components/shared/AppBanner';
import ProjectsGrid from '../components/projects/ProjectsGrid.vue';
import Button from '../components/reusable/Button.vue';
import TechCarousel from '@/components/shared/TechCarousel.vue';

export default {
	name: 'Home',
	components: {
		AppBanner,
		ProjectsGrid,
		Button,
		TechCarousel,
	},
};
</script>

<template>
	<div class="container mx-auto">
		<!-- Banner -->
		<AppBanner class="mb-5 sm:mb-8" />

		<!-- Projects -->
		<ProjectsGrid />

		<!-- Load more projects button -->
		<div class="mt-10 sm:mt-20 flex justify-center">
			<router-link
				to="/projects"
				class="font-sans font-medium flex items-center px-6 py-3 rounded-md border border-gray-300 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 text-black dark:text-white text-lg transition-colors duration-300"
				aria-label="More Projects"
			>
				<Button title="More Projects" />
			</router-link>
		</div>

		<!-- Skills -->
		<div class="mt-20 sm:mt-32">
			<h2 class="font-mono text-2xl font-bold mb-8 text-primary-dark dark:text-primary-light">
                > current_stack
            </h2>
			<TechCarousel />
		</div>
	</div>
</template>

<style scoped></style>
